(function () {

  'use strict';

  /* =====================================================
     ADD TO CART
     ===================================================== */

  document.addEventListener('submit', async function (event) {

    const form = event.target.closest('[data-add-form]');

    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('button');

    if (!button) return;

    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding...';

    try {

      const formData = new FormData(form);

      const response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Accept': 'application/json'
          },
          body: formData
        }
      );

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      const item = await response.json();

      button.textContent = 'Added ✓';

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: {
            item: item
          }
        })
      );

      document.dispatchEvent(
        new CustomEvent('vs:cart:updated', {
          detail: {
            item: item
          }
        })
      );

      /* Refresh cart drawer if theme supports it */

      if (typeof window.refreshCart === 'function') {
        window.refreshCart();
      }

      /* Common Shopify cart drawer events */

      document.dispatchEvent(
        new CustomEvent('cart:refresh')
      );

      setTimeout(function () {

        button.disabled = false;
        button.textContent = originalText;

      }, 1200);

    } catch (error) {

      console.error(
        'VS Product Card Add To Cart:',
        error
      );

      button.disabled = false;
      button.textContent = 'Try Again';

      setTimeout(function () {
        button.textContent = originalText;
      }, 1500);

    }

  });


  /* =====================================================
     BUY NOW
     ===================================================== */

  document.addEventListener('click', async function (event) {

    const button =
      event.target.closest('[data-buy-now]');

    if (!button) return;

    const variantId =
      button.dataset.variantId;

    if (!variantId) return;

    const originalText =
      button.innerHTML;

    button.disabled = true;
    button.textContent = 'Processing...';

    try {

      const response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            'Accept':
              'application/json'
          },

          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]
          })
        }
      );

      if (!response.ok) {
        throw new Error('Buy now failed');
      }

      window.location.href = '/checkout';

    } catch (error) {

      console.error(
        'VS Buy Now:',
        error
      );

      button.disabled = false;
      button.innerHTML = originalText;

    }

  });


  /* =====================================================
     QUICK VIEW
     ===================================================== */

  document.addEventListener('click', function (event) {

    const button =
      event.target.closest(
        '[data-action="quick-view"]'
      );

    if (!button) return;

    const handle =
      button.dataset.productHandle;

    if (!handle) return;

    /*
      Send event to existing theme Quick View system.
    */

    document.dispatchEvent(
      new CustomEvent(
        'vs:quick-view',
        {
          detail: {
            handle: handle
          }
        }
      )
    );

  });

})();